export const QUOTA_CATEGORY = {
  LAYERED: 'layered',
  GROUPED: 'grouped',
  NESTED: 'autoNested',
  // What legacy sends for an advanced-targeting question's own quotas.
  ADVANCE: 'advance',
} as const;

export const ALLOCATION_UNIT = {
  COMPLETES: 'completes',
  CLICKS: 'clicks',
} as const;

export type AllocationUnit =
  (typeof ALLOCATION_UNIT)[keyof typeof ALLOCATION_UNIT];

export const NESTED_QUOTA_DEFAULT_GROUP_ID = 'Nested';

export const NESTED_QUOTA_ALERT = {
  moreQuotasThanAllocation: (
    unit: AllocationUnit = ALLOCATION_UNIT.COMPLETES,
  ): string =>
    `There are more quotas than ${unit} available. Some nested quotas have 0 quantity available. This may cause unexpected behavior - please revise nested quotas if this warning is unexpected.`,
};
